import { e } from "./engine-is-deno.js";
import { e as o } from "./engine-is-node.js";
var n = !e && !o && "object" == typeof window && "object" == typeof document;
export { n as e };